module.exports = __webpack_public_path__ + "static/media/game-console-handheld.51fd2a7c.svg";